import React from 'react';
import { Box, Text, VStack, Circle, Button } from '@chakra-ui/react';
import { WarningIcon } from '@chakra-ui/icons';

interface TranscriptionErrorProps {
  onRestart: () => void;
}

function TranscriptionError({ onRestart }: TranscriptionErrorProps) {
  return (
    <Box
      position="absolute"
      top="0"
      left="0"
      right="0"
      bottom="0"
      bg="white"
      borderRadius="16px"
      display="flex"
      alignItems="center"
      justifyContent="center"
      zIndex="10"
    >
      <VStack spacing="20px" p="24px" textAlign="center">
        <Circle size="60px" bg="red.100" color="red.600" display="flex" alignItems="center" justifyContent="center">
          <WarningIcon boxSize="30px" />
        </Circle>

        <VStack spacing="8px">
          <Text fontSize="18px" fontWeight="600" color="red.600" textAlign="center">
            Erro na transcrição
          </Text>
          <Text fontSize="14px" color="gray.600" textAlign="center" lineHeight="1.4">
            Não foi possível transcrever o áudio. Tente gravar novamente.
          </Text>
        </VStack>

        <Button colorScheme="red" size="md" onClick={onRestart} _hover={{ bg: 'red.600' }} width="100%">
          Gravar novamente
        </Button>
      </VStack>
    </Box>
  );
}

export { TranscriptionError };
